export const deliveries = {
    namespaced: true,
    state: {
        calendarStatus: 'initial',
        calendar: [],
        calendarSummary: {
            week_net: 0,
            month_net: 0
        },
        nextStatus: 'initial',
        next: {},
        viewStatus: 'initial',
        view: {},
        cancelStatus: 'initial',
        upsell: {
            status: 'initial',
            errorMessage: '',
            upsellOrder: null,
            productsToUpsell: [],
            upsellProductsOrderId: null,
            upsellProductsStatus: false,
            upsellProductsErrorMessage: ''
        },
        cycleToChange: [],
        beforeUpsell: {},
        error: ''
    },
    mutations: {
        SET_CALENDAR_STATUS(state, calendarStatus) {
            state.calendarStatus = calendarStatus
        },
        SET_CALENDAR_SUMMARY(state, calendarSummary) {
            state.calendarSummary = calendarSummary
        },
        SET_CALENDAR(state, calendar) {
            state.calendar = calendar
        },
        SET_NEXT_STATUS(state, nextStatus) {
            state.nextStatus = nextStatus
        },
        SET_NEXT(state, next) {
            state.next = next
        },
        SET_VIEW_STATUS(state, viewStatus) {
            state.viewStatus = viewStatus
        },
        SET_VIEW(state, next) {
            state.next = next
        },
        SET_CANCEL_STATUS(state, cancelStatus) {
            state.cancelStatus = cancelStatus
        },
        SET_UPSELL_ERROR_MESSAGE(state, errorMessage) {
            state.upsell.errorMessage = errorMessage
        },
        SET_UPSELL_STATUS(state, status) {
            state.upsell.status = status
        },
        SET_ERROR_MESSAGE(state, error) {
            state.error = error
        },
        SET_UPSELL_PRODUCTS_STATUS(state, status) {
            state.upsell.upsellProductsStatus = status
        },
        SET_UPSELL_PRODUCTS_ERROR_MESSAGE(state, error) {
            state.upsell.upsellProductsErrorMessage = error
        },
        SET_BEFORE_UPSELL(state, payload) {
            state.beforeUpsell = payload
        },
        SET_UPSELL_PRODUCTS_ORDER_ID(state, payload) {
            state.upsell.upsellProductsOrderId = payload
        },
        SET_ONE_TIME_ORDER(state, payload) {
            state.upsell.isOneTimeOrder = payload
        },
        SET_CYCLE_TO_CHANGE(state, payload) {
            if (!state.cycleToChange.find(elem => elem.id === payload.id)) {
                state.cycleToChange.push(payload)
            } else {
                const index = state.cycleToChange.findIndex(elem => elem.id === payload.id)
                state.cycleToChange.splice(index, 1)
            }
        },
        RESET_CYCLE_TO_CHANGE(state) {
            state.cycleToChange = []
        }
    },
    actions: {
        fetchCalendar({ commit, getters, dispatch }, payload) {
            commit('SET_CALENDAR_STATUS', 'pending')
            return this.$api
                .get(
                    `client/v2/deliveries/calendar/${payload.month}/${payload.addressId}`
                )
                .then(response => {
                    commit('SET_CALENDAR', response.data.data.items)
                    commit('SET_CALENDAR_SUMMARY', response.data.data.summary)
                    commit('SET_CALENDAR_STATUS', 'idle')
                })
                .catch(() => {
                    dispatch(
                        'resetFromInitialState',
                        { module: 'deliveries' },
                        { root: true }
                    )
                })
        },
        fetchNext({ commit, getters, dispatch }, payload) {
            commit('SET_NEXT_STATUS', 'pending')
            return this.$api
                .get('client/v2/deliveries/next')
                .then(response => {
                    commit('SET_NEXT', response.data.data)
                    commit('SET_NEXT_STATUS', 'idle')
                })
                .catch(() => {
                    dispatch(
                        'resetFromInitialState',
                        { module: 'deliveries' },
                        { root: true }
                    ).then(() => {
                        commit('SET_NEXT_STATUS', 'empty')
                    })
                })
        },
        fetchView({ commit, getters, dispatch }, ids) {
            commit('SET_VIEW_STATUS', 'pending')
            return this.$api
                .get(`client/v2/deliveries/view?ids[]=${ids.map(item => item.id).join('&ids[]=')}`)
                .then(response => {
                    commit('SET_VIEW', response.data.data)
                    commit('SET_VIEW_STATUS', 'idle')
                })
                .catch(() => {
                    dispatch(
                        'resetFromInitialState',
                        { module: 'deliveries' },
                        { root: true }
                    )
                })
        },
        cancel({ commit, getters, dispatch }, id) {
            if (isNaN(id)) {
                return
            }
            commit('SET_CANCEL_STATUS', 'pending')
            return this.$api
                .get(`client/v2/deliveries/cancel/${id}`)
                .then(response => {
                    commit('SET_CANCEL_STATUS', 'idle')
                    return response
                })
                .catch(error => {
                    if (error.response.status === 406) {
                        commit(
                            'SET_ERROR_MESSAGE',
                            error.response.data.data.error
                        )
                        commit('SET_CANCEL_STATUS', 'idle')
                    } else {
                        dispatch(
                            'resetFromInitialState',
                            { module: 'deliveries' },
                            { root: true }
                        )
                    }
                    return error
                })
        },
        upsell({ commit, dispatch }, payload) {
            return this.$api
                .post('client/v2/deliveries/upsell', { deliveries: payload })
                .catch(error => {
                    commit('SET_UPSELL_STATUS', 'error')
                    commit(
                        'SET_UPSELL_ERROR_MESSAGE',
                        error.response.data.data.error
                    )
                })
        },
        setUpsellStatus({ commit }, payload) {
            commit('SET_UPSELL_STATUS', payload)
        },
        setBeforeUpsell({ commit }, payload) {
            commit('SET_BEFORE_UPSELL', payload)
        },
        async verifyOrderBeforeUpsell({ commit, dispatch }, payload) {
            try {
                const response = await this.$api.get(`client/v2/deliveries/before_change/${payload.id}`)
                dispatch('setBeforeUpsell', response.data.data)
                commit('SET_UPSELL_PRODUCTS_ORDER_ID', payload.id)
                if (response.data.data.upsell_allowed) {
                    commit('SET_UPSELL_PRODUCTS_STATUS', true)
                } else {
                    commit('SET_UPSELL_PRODUCTS_STATUS', false)
                    commit('SET_UPSELL_PRODUCTS_ERROR_MESSAGE', 'Dodanie produktu nie jest obecnie możliwe')
                    setTimeout(() => {
                        commit('SET_UPSELL_PRODUCTS_ERROR_MESSAGE', '')
                    }, 3000)
                }
                return response
            } catch(err) {
                console.log(err)
            }
        },
        async upsellSendProducts({ state, commit }, payload) {
            try {
                const response = await this.$api.post('client/v2/deliveries/additional_purchase', payload)
                return response
            } catch(err) {
                commit('SET_UPSELL_PRODUCTS_ERROR_MESSAGE', err.response.data.data.error)
                setTimeout(() => {
                    commit('SET_UPSELL_PRODUCTS_ERROR_MESSAGE', '')
                }, 4000)
                return err
            }
        },
        setProductToUpsell({ state, commit }, payload) {
            state.upsell.upsellOrder = payload.upsellOrder
        },
        setOneTimeOrder({ commit }, payload) {
            commit('SET_ONE_TIME_ORDER', payload)
        },
        setCycleToChange({ commit }, payload) {
            commit('SET_CYCLE_TO_CHANGE', payload)
        },
        resetCycleToChange({ commit }) {
            commit('RESET_CYCLE_TO_CHANGE')
        }
    },
    getters: {
        calendar: state => state.calendar,
        calendarStatus: state => state.calendarStatus,
        calendarSummary: state => state.calendarSummary,
        next: state => state.next,
        nextStatus: state => state.nextStatus,
        view: state => state.next,
        viewStatus: state => state.viewStatus,
        cancelStatus: state => state.cancelStatus,
        upsellErrorMessage: state => state.upsell.errorMessage,
        upsellStatus: state => state.upsell.status,
        upsellProductsOrderId: state => state.upsell.upsellProductsOrderId,
        upsellProductsStatus: state => state.upsell.upsellProductsStatus,
        upsellProductsErrorMessage: state => state.upsell.upsellProductsErrorMessage,
        beforeUpsell: state => state.beforeUpsell,
        isOneTimeOrder: state => state.upsell.isOneTimeOrder,
        error: state => state.error,
        cycleToChange: state => state.cycleToChange
    }
}
